import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';

export function isWorkflowCreateTaskFormsEnabled(): boolean {
  // Forms are only enabled for those with Workflows
  return isFeatureEnabled({feature: ProcessesFeature.PROCESSES_DISCOVER});
}
